import { appNameList } from '@/globalConstants';

const sidebarLinks = [
	{
		name: 'Rezervace',
		icon: 'nc-icon nc-calendar-60',
		path: '/logistika/rezervace',
	},
	{
		name: 'Nová trasa',
		icon: 'nc-icon nc-compass-05',
		path: '/logistika/nova-trasa',
	},
	{
		name: 'Report',
		icon: 'nc-icon nc-paper',
		path: '/logistika/report',
	},
	{
		name: 'Pošta',
		icon: 'nc-icon nc-email-85',
		path: '/logistika/postovni-zasilky',
	},
	{
		name: 'Statistiky',
		icon: 'nc-icon nc-single-copy-04',
		path: '/logistika/statistiky',
	},
	{
		name: 'Oblečení',
		icon: 'nc-icon nc-cart-simple',
		path: '/logistika/svoz-obleceni',
	},
];

const sidebarUserLinks = [
	{ name: 'driver-list', display: 'Řidiči' },
	{ name: 'password-change', display: 'Změna hesla' },
	{ name: 'settings', display: 'Nastavení' },
];

const config = {
	appName: appNameList.logistics,
	sidebarLinks,
	sidebarUserLinks,
};

config.install = function (Vue) {
	Vue.prototype.$getConst = (key) => config[key];
};

export const appName = appNameList.logistics;

export default config;
